import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DataAccessFairsFacade } from '@planone/bau365/data-access-fair-data';
import { DataAccessSearchPageFacade, DataAccessSearchService, SearchType } from '@planone/bau365/data-access-search';
import { map, Observable, switchMap } from 'rxjs';

@Component({
  selector: 'bau365-display-name-search-input',
  templateUrl: './display-name-search-input.component.html',
})
export class DisplayNameSearchInputComponent {
  @Input()
  entityType = '';

  @Input()
  submittedSearchTerm = '';

  @Input()
  size: string | undefined | null;

  @Input()
  placeholderText: string | undefined;

  @Output()
  searchTerm: EventEmitter<string> = new EventEmitter<string>();

  options$: Observable<string[]> | undefined;

  constructor(
    private searchService: DataAccessSearchService,
    private fairsFacade: DataAccessFairsFacade,
    public searchPageFacade: DataAccessSearchPageFacade
  ) {}

  searchSuggestions(searchTerm: string) {
    if (searchTerm) {
      this.options$ = this.fairsFacade.fairId$
        .pipe(
          switchMap((fairId) =>
            this.searchService.getDisplayNameAutocompleteSuggestion(
              [SearchType.exhibitor, SearchType.brand],
              searchTerm,
              fairId
            )
          )
        )
        .pipe(
          map((response) => {
            return response.suggestions.map((sug) => sug.suggestion);
          })
        );
    } else {
      this.searchSubmitted('');
    }
  }

  searchSubmitted(searchTerm: string) {
    this.searchTerm.emit(searchTerm);
  }
}
